import React, {Component} from 'react';
import TSelectForm from "./TSelectForm";

class TSelect extends Component {
    constructor(props) {
        super(props);
    }

    render() {

        const { defaultClassName, propertyName, optionList, selected, selectItem } = this.props;

        const items = optionList[propertyName];
        const selectedValue = selected[propertyName];

        return (
        	<TSelectForm className={defaultClassName} items={items} selected={selectedValue} onSelect={item => selectItem(propertyName, item.value)} />
        )
    }
}

export default TSelect;
